import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var MatchPipe = (function () {
    function MatchPipe() {
    }
    MatchPipe.prototype.transform = function (text, pattern, flags) {
        if (!isString(text)) {
            return text;
        }
        return text.match(new RegExp(pattern, flags));
    };
    return MatchPipe;
}());
export { MatchPipe };
MatchPipe.decorators = [
    { type: Pipe, args: [{ name: 'match' },] },
];
/** @nocollapse */
MatchPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=match.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/match.js
// module id = 261
// module chunks = 4